import A11yDialog from 'a11y-dialog';

$(document).ready(function () {
    $('.variableModalContainer').each(function () {
        const $this = $(this);

        var id = $this.attr('id'); // Ensure your modalContainer element has a unique ID
        var container = document.getElementById(id);
        var dialog = new A11yDialog(container);

        // Add a show event listener
        dialog.on('show', function () {
            $('body').addClass('__modal');
            $this.attr('aria-hidden', 'false');
            $this.attr('tabindex', '0');

            // Focus the close button
            $this.find('.variableModalCloseButton').eq(0).focus();
        });

        dialog.on('hide', function () {
            $('body').removeClass('__modal');
            $this.attr('tabindex', '-1');
            dialog.hide();
            $this.attr('aria-hidden', 'true');
        });

        // Add a close button click handler
        $('.variableModalCloseButton').click(function () {
            $('body').removeClass('__modal');
            $this.attr('tabindex', '-1');
            dialog.hide();
            $this.attr('aria-hidden', 'true');
        });

        function shouldShowModalFromHash(hash) {
            return hash == ('#' + $this.attr('id'));
        }

        // Detect hash change or URL reload
        if (shouldShowModalFromHash(window.location.hash)) {
            dialog.show();
            $('body').addClass('__modal');
            $this.attr('aria-hidden', 'false');
            $this.attr('tabindex', '0');

            // focus handled in dialog open
        }

        // Listen for hash changes dynamically
        window.addEventListener('hashchange', function () {
            if (shouldShowModalFromHash(window.location.hash)) {
                dialog.show();
                $('body').addClass('__modal');
                $this.attr('aria-hidden', 'false');
                $this.attr('tabindex', '0');
                
                // focus handled in dialog open
            }
        });
    });
});
